import { IntegrationTypes } from 'shared/CSharedConstants';

export const getIntegrationType = (name) => {
  if (Object.values(IntegrationTypes).includes(name)) {
    return name;
  }

  return IntegrationTypes.NONE;
};
